export default theme => ({
  hover: {
    '&:hover': {
      opacity: 1,
    },
    opacity: 0,
    bottom: 30,
    left: 15,
    fontSize: 26,
    position: 'absolute',
    color: 'black',
    lineHeight: 1,
    zIndex: 300,
    transition: 'opacity 0.3s',
    // zIndex: 100,
  },
});
